import { useMutation } from '@tanstack/react-query';
import { userApi } from '../userApi';
import { MutationKey } from '@shared/config';

export const useExportUsers = () => {
  return useMutation({
    mutationKey: [MutationKey.EXPORT_VACANCY],
    mutationFn: async ({
      dateFrom,
      dateTo,
    }: {
      dateFrom: string | null;
      dateTo?: string | null;
    }) => {
      const response = userApi.exportUsers({ dateFrom, dateTo });
      return response;
    },
  });
};
